import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import useFocusTrap from "../hooks/useFocusTrap";

export default function Modal({ open, onClose, title, children }) {
  const panelRef = useRef(null);

  useFocusTrap(panelRef, open);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div
      className="modal-overlay"
      role="dialog"
      aria-modal="true"
      onClick={(e) => {
        // Only close if clicking directly on the overlay, not its children
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
      data-lenis-prevent
    >
      <div
        className="modal-panel"
        ref={panelRef}
        tabIndex={-1}
        onClick={(e) => e.stopPropagation()}
        data-lenis-prevent
      >
        <button className="modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>

        {title ? <h2 className="modal-title">{title}</h2> : null}

        <div className="modal-body" data-lenis-prevent>
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
}
